import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface EnergyState {
  electricityExpenseMonthly: number;
  naturalGasExpenseMonthly: number;
  dieselExpenseMonthly: number;
  LPGExpenseMonthly: number;
  butaneUseMonthly: number;
  propaneUseMonthly: number;
}

const initialState: EnergyState = {
  electricityExpenseMonthly: 0,
  naturalGasExpenseMonthly: 0,
  dieselExpenseMonthly: 0,
  LPGExpenseMonthly: 0,
  butaneUseMonthly: 0,
  propaneUseMonthly: 0,
};

export const energySlice = createSlice({
  name: "energy",
  initialState,
  reducers: {
    setElectricityExpenseMonthly(state, action: PayloadAction<number>) {
      state.electricityExpenseMonthly = action.payload;
    },
    setNaturalGasExpenseMonthly(state, action: PayloadAction<number>) {
      state.naturalGasExpenseMonthly = action.payload;
    },
    setDieselExpenseMonthly(state, action: PayloadAction<number>) {
      state.dieselExpenseMonthly = action.payload;
    },
    setLPGExpenseMonthly(state, action: PayloadAction<number>) {
      state.LPGExpenseMonthly = action.payload;
    },
    setButaneUseMonthly(state, action: PayloadAction<number>) {
      state.butaneUseMonthly = action.payload;
    },
    setPropaneUseMonthly(state, action: PayloadAction<number>) {
      state.propaneUseMonthly = action.payload;
    },
    setEnergyState(state, action: PayloadAction<EnergyState>) {
      state = action.payload;
    },
  },
});

export const {
  setElectricityExpenseMonthly,
  setNaturalGasExpenseMonthly,
  setDieselExpenseMonthly,
  setLPGExpenseMonthly,
  setButaneUseMonthly,
  setPropaneUseMonthly,
  setEnergyState,
} = energySlice.actions;

export default energySlice.reducer;
